import { PlayerState } from './constants.js';

const noop = () => {
};
const EMPTY_ARRAY = [];
const UNLOADED_STATES = /* @__PURE__ */ new Set([
  PlayerState.UNKNOWN,
  PlayerState.UNLOADING,
  PlayerState.UNLOADED,
  PlayerState.LOADING
]);
function isPlayerLoaded(playerState) {
  return !UNLOADED_STATES.has(playerState);
}

export { EMPTY_ARRAY, UNLOADED_STATES, isPlayerLoaded, noop };
//# sourceMappingURL=utils.js.map
